<!--suppress ALL -->
<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 mt-1 pt-md-0 pt-0 pb-0 shadow-lg col-xs-12 col-lg-8"
>
  <div class="jumbotron-fluid mb-0 pb-0">
    <div class="card-body mt-1 pt-2 mb-0 pb-3 shadow-lg">
      <h3 class="text-info d-flex justify-content-center mt-2 pt-1 mb-3">
        Register
      </h3>
      <form
        (ngSubmit)="register()"
        [formGroup]="userForm"
      >
        <div class="row">
          <div class="form-group text-primary col-12 col-md-6">
            <label
              [ngClass]="fval.full_name.valid ? 'text-info' : ''"
              for="full_name"
            >Full Name<i
                *ngIf="fval.full_name.valid"
                class="material-icons"
              >check_circle</i></label>
            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-user text-primary mx-auto"
                    style="size: 50px;"
                  >
                  </i>
                </div>
              </div>
              <input
                [ngClass]="{
              'is-invalid':
                (fval.full_name.touched || fval.full_name.dirty) &&
                fval.full_name.errors
            }"
                autocomplete="off"
                class="form-control"
                formControlName="full_name"
                id="full_name"
                placeholder="Enter Name"
                type="text"
              />
            </div>
            <div
              *ngIf="
            (fval.full_name.touched || fval.full_name.dirty) &&
            fval.full_name.errors?.required
          "
              class="text-danger col"
            >
              The full name is required!
            </div>
          </div>
          <div class="form-group text-primary col-12 col-md-6">
            <label
              [ngClass]="fval.date_of_birth.valid ? 'text-info' : ''"
              for="date_of_birth"
            >Date Of Birth<i
                *ngIf="fval.date_of_birth.valid"
                class="material-icons"
              >check_circle</i></label>

            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-calendar-alt text-primary mx-auto"
                    style="size: 50px;"
                  >
                  </i>
                </div>
              </div>
              <input
                [bsConfig]="{
                      containerClass: 'theme-blue',
              dateInputFormat: 'MM/DD/YYYY', isAnimated: true }"
                [ngClass]="{
              'is-invalid':
                (fval.date_of_birth.touched || fval.date_of_birth.dirty) &&
                fval.date_of_birth.errors
            }"
                autocomplete="off"
                bsDatepicker
                class="form-control"
                formControlName="date_of_birth"
                id="date_of_birth"
                placeholder="Click to select Date Of Birth"
                placement="bottom"
                type="text"
              />
            </div>
            <div
              *ngIf="
            (fval.date_of_birth.touched || fval.date_of_birth.dirty) &&
            fval.date_of_birth.errors?.required
          "
              class="text-danger col"
            >
              The date of birth is required!
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group text-primary col-12 col-md-6">
            <label
              [ngClass]="fval.id_type.valid ? 'text-info' : ''"
              for="id_type"
            >
              ID Type<i
                *ngIf="fval.id_type.valid"
                class="material-icons"
              >check_circle</i>
            </label>
            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-user-tag text-primary mx-auto"
                    style="size: 50px;"
                  >
                  </i>
                </div>
              </div>
              <select
                (change)='setSelectedChanges(fval.id_type.value)'
                [ngClass]="{
            'is-invalid':
              (fval.id_type.touched || fval.id_type.dirty) &&
              fval.id_type.errors
          }"
                autocomplete="off"
                class="form-control"
                formControlName="id_type"
              >
                <option
                  class="place-holder-select"
                  disabled
                  hidden
                  selected
                  value=""
                >Select ID Type</option>
                <option>NATIONAL ID</option>
                <option>PASSPORT</option>
                <option>DRIVING PERMIT</option>
                <option>VILLAGE ID</option>
              </select>
            </div>
            <div
              *ngIf="
            (fval.id_type.touched || fval.id_type.dirty) &&
            fval.id_type.errors?.required
          "
              class="text-danger col"
            >
              The ID type is required!
            </div>
          </div>
          <div class="form-group text-primary col-12 col-md-6">
            <label
              class="text-info"
              for="idPhotoUrl"
            >
              ID Upload<span class="text-primary"> (Optional)</span>
            </label>
            <!-- [ngClass]="fval.idPhotoUrl.valid ? 'text-info' : ''" -->
            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-image text-primary mx-auto"
                    style="size: 50px"
                  ></i>
                </div>
              </div>
              <input
                (change)="onFileSelected($event)"
                [ngClass]="{
                'is-invalid':
                  (fval.idPhotoUrl.touched ||
                    fval.idPhotoUrl.dirty) &&
                  fval.idPhotoUrl.errors
              }"
                capture
                class="form-control"
                formControlName="idPhotoUrl"
                id="idPhotoUrl"
                src="image/*"
                type="file"
              />
            </div>
            <div
              *ngIf="
              (fval.idPhotoUrl.touched || fval.idPhotoUrl.dirty) &&
              fval.idPhotoUrl.errors?.required
            "
              class="text-danger col"
            >
              Please upload a photo of the client's ID'!
            </div>
          </div>
        </div>
        <!-- </div> -->
        <div class="row">
          <div class="form-group text-primary col-12 col-md-6">
            <label
              [ngClass]="fval.id_number.valid ? 'text-info' : ''"
              for="id_number"
            >ID Number<i
                *ngIf="fval.id_number.valid"
                class="material-icons"
              >check_circle</i></label>
            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-id-card text-primary mx-auto"
                    style="size: 50px"
                  ></i>
                </div>
              </div>
              <input
                [ngClass]="{
              'is-invalid':
                (fval.id_number.touched || fval.id_number.dirty) &&
                fval.id_number.errors
            }"
                autocomplete="off"
                class="form-control"
                formControlName="id_number"
                id="id_number"
                placeholder="Enter your ID number"
                type="text"
              />
            </div>
            <div
              *ngIf="
            (fval.id_number.touched || fval.id_number.dirty) &&
            fval.id_number.errors?.required
          "
              class="text-danger col"
            >
              The ID number is required!
            </div>
          </div>
          <div class="form-group text-primary col-12 col-md-6">
            <label
              class="text-info"
              for="email"
            >
              Email<span class="text-primary"> (Optional)</span>
            </label>
            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-envelope text-primary mx-auto"
                    style="size: 50px;"
                  ></i>
                </div>
              </div>
              <input
                [ngClass]="{
              'is-invalid':
                (fval.email.touched || fval.email.dirty) && fval.email.errors
            }"
                autocomplete="off"
                class="form-control"
                formControlName="email"
                id="email"
                placeholder="Email address (Optional)"
                type="text"
              />
            </div>
            <div
              *ngIf="
            (fval.email.touched ||
            fval.email.dirty) &&
          fval.email.errors?.pattern
          "
              class="text-danger col"
            >
              Please enter valid email address!
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group text-primary col-12 col-md-6">
            <label
              [ngClass]="fval.user_contact_number.valid ? 'text-info' : ''"
              for="user_contact_number"
            >Phone Number<i
                *ngIf="fval.user_contact_number.valid"
                class="material-icons"
              >check_circle</i></label>
            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-phone text-primary mx-auto"
                    style="size: 50px;"
                  ></i>
                </div>
              </div>
              <input
                [ngClass]="{
              'is-invalid':
                (fval.user_contact_number.touched ||
                  fval.user_contact_number.dirty) &&
                fval.user_contact_number.errors
            }"
                autocomplete="off"
                class="form-control"
                formControlName="user_contact_number"
                id="user_contact_number"
                placeholder="e.g. 07XXXXXXXX"
                type="text"
              />
            </div>
            <div
              *ngIf="
            (fval.user_contact_number.touched ||
              fval.user_contact_number.dirty) &&
            fval.user_contact_number.errors?.required
          "
              class="text-danger col"
            >
              The phone number is required!
            </div>
            <div
              *ngIf="
            (fval.user_contact_number.touched ||
              fval.user_contact_number.dirty) &&
            fval.user_contact_number.errors?.hasNumber
          "
              class="text-danger col"
            >
              The phone number should be equal to 10 "digits"!
            </div>
          </div>
          <div class="form-group text-primary col-12 col-md-6">
            <label
              [ngClass]="fval.position.valid ? 'text-info' : ''"
              for="position"
            >
              Position<i
                *ngIf="fval.position.valid"
                class="material-icons"
              >check_circle</i>
            </label>
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-user-cog text-primary mx-auto"
                    style="size: 50px;"
                  >
                  </i>
                </div>
              </div>
              <select
                (change)='setSelectedChanges(fval.position.value)'
                [ngClass]="{
              'is-invalid':
                (fval.position.touched || fval.position.dirty) &&
                fval.position.errors
            }"
                autocomplete="off"
                class="form-control"
                formControlName="position"
                placeholder="Select Position"
              >
                <option
                  class="place-holder-select"
                  disabled
                  hidden
                  selected
                  value=""
                >Select Position</option>
                <option
                  *ngFor="let role of roles"
                  [value]="role.accessRightsId"
                >
                  {{role.roleName}}
                </option>
              </select>
              <div
                *ngIf="
            (fval.position.touched || fval.position.dirty) &&
            fval.position.errors?.required
          "
                class="text-danger col"
              >
                The position is required!
              </div>
            </div>
          </div>
        </div>
        <!--the divs below will appear depending on the position selected-->
        <div
          *ngIf="fval.position.value == 100"
          class="form-group text-primary"
        >
          <label
            [ngClass]="fval.central.valid ? 'text-info' : ''"
            for="central"
          >Choose Unit<i
              *ngIf="fval.central.valid"
              class="material-icons"
            >check_circle</i></label>
          <div class="input-group mb-0">
            <select
              [ngClass]="{
              'is-invalid':
                (fval.central.touched || fval.central.dirty) &&
                fval.central.errors
            }"
              autocomplete="off"
              class="form-control"
              formControlName="central"
              placeholder="Select Unit"
            >
              <option
                class="place-holder-select"
                disabled
                hidden
                selected
                value=""
              >Select Business Unit</option>
              <option
                *ngFor="let unit of units"
                [value]="unit.theBusinessUnitId"
              >
                {{unit.bussinessUnitName}}
              </option>
            </select>
          </div>
          <div
            *ngIf="
              (fval.central.touched || fval.central.dirty) &&
              fval.central.errors?.required
            "
            class="text-danger col"
          >
            The unit is required!
          </div>
        </div>
        <div
          *ngIf="fval.position.value == 200"
          class="form-group text-primary"
        >
          <label
            [ngClass]="fval.area.valid ? 'text-info' : ''"
            for="area"
          >Choose Region<i
              *ngIf="fval.area.valid"
              class="material-icons"
            >check_circle</i></label>
          <div class="input-group mb-0">
            <select
              [ngClass]="{
              'is-invalid':
                (fval.area.touched || fval.area.dirty) &&
                fval.area.errors
            }"
              autocomplete="off"
              class="form-control"
              formControlName="area"
              placeholder="Select Region"
            >
              <option
                class="place-holder-select"
                disabled
                hidden
                selected
                value=""
              >Select Area Location</option>
              <option
                *ngFor="let area of areas"
                [value]="area.theAreaLocationId"
              >
                {{area.areaRegionName.toUpperCase()}}
              </option>
            </select>
          </div>
          <div
            *ngIf="
              (fval.area.touched || fval.area.dirty) &&
              fval.area.errors?.required
            "
            class="text-danger col"
          >
            The region is required!
          </div>
        </div>
        <!--the div for town-->
        <div
          *ngIf="fval.position.value == 300"
          class="form-group text-primary"
        >
          <label
            [ngClass]="fval.town.valid ? 'text-info' : ''"
            for="town"
          >Choose Town<i
              *ngIf="fval.town.valid"
              class="material-icons"
            >check_circle</i></label>
          <div class="input-group mb-0">
            <select
              [ngClass]="{
              'is-invalid':
                (fval.town.touched || fval.town.dirty) &&
                fval.town.errors
            }"
              autocomplete="off"
              class="form-control"
              formControlName="town"
              placeholder="Select town"
            >
              <option
                class="place-holder-select"
                disabled
                hidden
                selected
                value=""
              >Select Town Location</option>
              <option
                *ngFor="let town of towns"
                [value]="town.theTownLocationId"
              >
                {{town.townName.toUpperCase()}}
              </option>
            </select>
          </div>
          <div
            *ngIf="
              (fval.town.touched || fval.town.dirty) &&
              fval.town.errors?.required
            "
            class="text-danger col"
          >
            The town is required!
          </div>
        </div>

        <!--the div for station-->
        <div
          *ngIf="fval.position.value == 400"
          class="form-group text-primary"
        >
          <label
            [ngClass]="fval.station.valid ? 'text-info' : ''"
            for="station"
          >Choose station<i
              *ngIf="fval.station.valid"
              class="material-icons"
            >check_circle</i></label>
          <div class="input-group mb-2">
            <select
              [ngClass]="{
              'is-invalid':
                (fval.station.touched || fval.station.dirty) &&
                fval.station.errors
            }"
              autocomplete="off"
              class="form-control"
              formControlName="station"
              placeholder="Select station"
            >
              <option
                class="place-holder-select"
                disabled
                hidden
                selected
                value=""
              >Select Station Location</option>
              <option
                *ngFor="let station of stations"
                [value]="station.theStationLocationId"
              >
                {{station.stationName.toUpperCase()}}
              </option>
            </select>
          </div>
          <div
            *ngIf="
              (fval.station.touched || fval.station.dirty) &&
              fval.station.errors?.required
            "
            class="text-danger col"
          >
            The station is required!
          </div>
        </div>
        <div class="row">
          <div class="form-group text-primary col-12 col-md-6">
            <label
              [ngClass]="fval.password.valid ? 'text-info' : ''"
              for="password"
            >Create PIN<i
                *ngIf="fval.password.valid"
                class="material-icons"
              >check_circle</i></label>

            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-lock text-primary mx-auto"
                    style="size: 50px"
                  ></i>
                </div>
              </div>
              <input
                [ngClass]="{
                'is-invalid':
                  (fval.password.touched || fval.password.dirty) &&
                  fval.password.errors
              }"
                [type]="fieldType ? 'text' : 'password'"
                autocomplete="off"
                class="form-control"
                formControlName="password"
                id="password"
                placeholder="Enter your PIN"
              />
              <div class="input-group-append">
                <span class="input-group-text">
                  <i
                    (click)="toggleFieldType()"
                    [ngClass]="{
                    'fa-eye-slash': !fieldType,
                    'fa-eye': fieldType
                  }"
                    class="fas"
                  ></i>
                </span>
              </div>
            </div>
            <div
              *ngIf="
              (fval.password.touched || fval.password.dirty) &&
              fval.password.errors?.required
            "
              class="text-danger col"
            >
              Your PIN is required!
            </div>

            <div
              *ngIf="
              (fval.password.touched || fval.password.dirty) &&
              fval.password.invalid
            "
              [ngClass]="
              fval.password.errors?.required ||
              fval.password.errors?.minlength ||
              fval.password.errors?.maxlength
                ? 'text-danger'
                : 'text-info'
            "
              class="col"
            >
              <i class="material-icons">{{
                fval.password.errors?.required ||
                fval.password.errors?.minlength ||
                fval.password.errors?.maxlength
                ? "cancel"
                : "check_circle"
                }}</i>
              PIN should have exactly four digits!
            </div>
            <div
              *ngIf="
              (fval.password.touched || fval.password.dirty) &&
              fval.password.invalid
            "
              [ngClass]="
              fval.password.hasError('required') ||
              fval.password.hasError('hasNumber')
                ? 'text-danger'
                : 'text-info'
            "
              class="col"
            >
              <i class="material-icons">{{
                fval.password.hasError("required") ||
                fval.password.hasError("hasNumber")
                ? "cancel"
                : "check_circle"
                }}</i>
              Only digits are allowed!
            </div>
          </div>
          <div class="form-group text-primary col-12 col-md-6">
            <label
              [ngClass]="fval.confirmPassword.valid ? 'text-info' : ''"
              for="confirmPassword"
            >Confirm PIN<i
                *ngIf="fval.confirmPassword.valid"
                class="material-icons"
              >check_circle</i></label>

            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-lock text-primary mx-auto"
                    style="size: 50px"
                  ></i>
                </div>
              </div>
              <input
                [ngClass]="{
                'is-invalid':
                  (fval.confirmPassword.touched ||
                    fval.confirmPassword.dirty) &&
                  fval.confirmPassword.errors
              }"
                [type]="fieldType ? 'text' : 'password'"
                autocomplete="off"
                class="form-control"
                formControlName="confirmPassword"
                id="confirmPassword"
                placeholder="Confirm your PIN"
              />
              <div class="input-group-append">
                <span class="input-group-text">
                  <i
                    (click)="toggleFieldType()"
                    [ngClass]="{
                    'fa-eye-slash': !fieldType,
                    'fa-eye': fieldType
                  }"
                    class="fas"
                  ></i>
                </span>
              </div>
            </div>

            <div
              *ngIf="fval.confirmPassword.errors?.NoPasswordMatch"
              class="text-danger col"
            >
              PINs do not match
            </div>
            <div
              *ngIf="
              fval.confirmPassword.errors?.required &&
              (fval.confirmPassword.touched || fval.confirmPassword.dirty)
            "
              class="text-danger col"
            >
              Please confirm your PIN
            </div>
          </div>
        </div>
        <div class="d-flex my-2 py-2 mx-auto">
          <ngx-alerts></ngx-alerts>
          <button
            (click)="returnHome()"
            class="btn btn-info col-5 mx-auto"
            routerLink="/authpage/login"
            type="button"
          >
            Sign In
          </button>
          <button
            [disabled]="!userForm.valid || loading"
            class="btn btn-info col-5 mx-auto"
            type="submit"
          >
            Register
          </button>
        </div>
      </form>
      <!-- </div>  -->
      <!-- </div>   -->
    </div>
  </div>
</div>
<!--footer -->
<div class="d-flex justify-content-center col-xs-12 col-lg-12 mt-3 mb-2 mx-auto">
  <div class="small text-center text-primo">
    &copy; 2021 - ThunderBolt
  </div>
</div>
